// extracted by mini-css-extract-plugin
export default {"body":"c3tD23WFy2pnnKL4NzEp"};